import * as imageService from '../utils/img';

export default imageService;
